import Vue from 'vue';

//displays the red and turns it back to blue on errors
Vue.directive('error-message', {
    bind: function (el, binding, vnode) {

        //bind the error model so we can watch for errors coming in or going out
        vnode.context.$watch(binding.value.errorModel, runValidation);

        function runValidation(newValue, oldValue) {

            if (newValue && newValue.length > 0) {

                //don't want to re-add the same class then we would have 2 is-invalid's on the same object
                if (el.className.indexOf('is-invalid') === -1) {
                    el.className = el.className + ' is-invalid';
                }
            }
            else {
                clearError(el);
            }
        }

        function clearError(element) {

            //remove the error array from the model
            deleteErrorFromModel(vnode.context, binding.value.errorModel, vnode.context);

            element.className = element.className.replace('is-invalid', '');
        }

        function deleteErrorFromModel(data, errorModel, vNodeContext) {
            let split = errorModel.split('.');
            let tmpObject = data;

            for (i = 0; i < split.length - 1; i++) {
                tmpObject = tmpObject[split[i]];
            }
            
            vNodeContext.$delete(tmpObject, split[split.length - 1]);
        }

        //allow you to clear the error on a different v-model...so additional parameters
        //v-error-message="{ errorModel: 'errorModel.q' + model.questionId, clearErrorOnChangeModel: ['firstName'] }"
        if (binding.value.clearErrorOnChangeModel) {

            for (var i = 0; i < binding.value.clearErrorOnChangeModel.length; i++) {
                vnode.context.$watch(binding.value.clearErrorOnChangeModel[i], function (newValue, oldValue) {
                    clearError(el);
                });
            }
        }

        let model = vnode.data.directives.filter(x => x.name === 'model')[0];

        if (!model) {
            model = vnode.data.model;
        }

        if (model) {

            //watch the model so we can auto hide the error divs
            vnode.context.$watch(model.expression, function (newValue, oldValue) {

                //compare nulls is fine
                if (newValue != oldValue) {
                    clearError(el);
                }
            });
        }
    },
});

Vue.filter('firstError', function GetFirstValidationError(value) {
    if (!value) {
        return ''
    }
    
    if (typeof value === 'string') return value;

    return value[0];
});

Vue.filter('capitalizeFirstLetter', function GetFirstValidationError(value) {
    if (!value) {
        return ''
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
});